import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import { t } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { SpaceType } from 'APP/model/space/spaceModel.types';
import { RouterPage } from 'APP/router/constants';
import { useNavigateTo } from 'APP/router/hooks/useNavigateTo';

import { CreateSpaceStep, ISpaceFormData } from '../../components/SpaceForm/SpaceForm.presenter';

interface ICreateSpacePopupPresenter {
  initialValues: ISpaceFormData;
  step: CreateSpaceStep;
  isShowPrevStep: boolean;
  onStepChange(step: CreateSpaceStep): void;
  onShowPrevStep(): void;
  onSubmit(spaceData: ISpaceFormData): Promise<void>;
}

export function useCreateSpacePopupPresenter({
  popupInstance,
}: ICommonPopupsProps): ICreateSpacePopupPresenter {
  const navigateTo = useNavigateTo();
  const source = useAsObservableSource({ navigateTo });

  const presenter = useLocalStore<ICreateSpacePopupPresenter>(() => ({
    initialValues: {
      name: '',
      type: SpaceType.Public,
      categoryId: '',
    },
    step: CreateSpaceStep.GeneralInfo,

    get isShowPrevStep(): boolean {
      return presenter.step === CreateSpaceStep.AdditionalInfo;
    },

    onShowPrevStep(): void {
      presenter.step = CreateSpaceStep.GeneralInfo;
    },

    onStepChange(step: CreateSpaceStep): void {
      presenter.step = step;
    },

    async onSubmit(spaceData: ISpaceFormData): Promise<void> {
      const space = await Tasks.space.createSpace({
        ...spaceData,
        deepLinkAlias: spaceData.type === SpaceType.Public ? spaceData.deepLinkAlias : undefined,
      });

      if (space) {
        source.navigateTo({
          to: `/${RouterPage.Spaces}/${space.id}`,
        });
      } else {
        Tasks.app.showAlert(t('common_somethings_wrong_error'));
      }
      popupInstance.close();
    },
  }));

  return presenter;
}
